// Pounce screens pe team member kya kar sakta hai. Owner ko sab kuch.
//
// Niyam wahi jo backend ke Pounce routes pe hain (server/src/routes/
// pounceRoutes.js) — UI sirf button band/khula dikhata hai, asli rok server pe
// hai:
//   canViewLeads        — viewCallLogs: leads + recordings
//   canViewAppointments — viewAppointments
//   canEdit             — editAgents: lead jodna, dobara call, invalid, on/off,
//                         settings, qualifying questions
//   canManage           — sirf owner/admin: connectors (secret key), plan
import useAgentPermissions from "./useAgentPermissions";
import { getActiveOwnerId } from "../lib/activeContext";

export const POUNCE_LOCK_MESSAGE = "You don't have permission for this. Ask the account owner.";

const usePounceAccess = (ownerId) => {
  // Backend bhi isi active owner (X-Owner-Id) pe scope karta hai.
  const owner =
    ownerId ||
    getActiveOwnerId() ||
    sessionStorage.getItem("SelectAgentOwnerId") ||
    localStorage.getItem("teamOwnerId") ||
    undefined;
  const perms = useAgentPermissions(owner);

  return {
    isTeamMember: perms.isTeamMember,
    canViewLeads: perms.canViewCallLogs,
    canViewAppointments: perms.canViewAppointments,
    canEdit: perms.canEditAgents,
    canManage: perms.isAdmin,
  };
};

export default usePounceAccess;
